<template>
  <div class="order-page">
    <el-card class="box-card">
      <el-form :model="form"
               label-width="70px"
               style="width: 100%">
        <el-row>
          <el-col :span="6">
            <el-form-item prop="platCode"
                          label="行业">
              <el-select clearable
                         v-model="form.profession"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in platlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="business"
                          label-width="80px"
                          label="商家">
              <el-select v-loading="ptnListLoading"
                         clearable
                         v-model="form.business"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in ptnlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="store"
                          label-width="80px"
                          label="店铺">
              <el-select v-loading="shopListLoading"
                         clearable
                         v-model="form.store"
                         @change="getBuyerLevel"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in shoplists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card class="button-box"
             v-if="form.store">
      <el-row>
        <el-col>
          <el-button type="primary"
                     :loading="loading"
                     icon="el-icon-circle-plus-outline"
                     @click="handleAdd">新增配置</el-button>
          <el-button :type="setFlag?'info':'danger'"
                     :loading="loading"
                     v-if="getBuyerLevelData.length>0"
                     icon='el-icon-edit'
                     @click="handleSet">{{setFlag?"取消编辑配置":"编辑删除配置"}}</el-button>
          <!-- <span class="title"
                v-if="getBuyerLevelData.length>0 && !setFlag">双击表格可直接进入编辑模式</span> -->

        </el-col>
        <!-- <el-col :span="3"
                class="title">双击表格可直接进入编辑模式</el-col> -->

      </el-row>
    </el-card>
    <el-card class="
                     button-box"
             v-if="!form.profession||!form.store||!form.business">

      <el-row type="flex"
              justify="center">
        <el-col :sm="12"
                :lg="6">

          <div class="el-result">
            <div class="el-result__icon">
              <svg viewBox="0 0 48 48"
                   xmlns="http://www.w3.org/2000/svg"
                   class="icon-info">
                <path
                      d="M24,4 C35.045695,4 44,12.954305 44,24 C44,35.045695 35.045695,44 24,44 C12.954305,44 4,35.045695 4,24 C4,12.954305 12.954305,4 24,4 Z M24,19 L21,19 C20.1715729,19 19.5,19.6715729 19.5,20.5 C19.5,21.3284271 20.1715729,22 21,22 L21,22 L22.5,22 L22.5,31 L21,31 C20.1715729,31 19.5,31.6715729 19.5,32.5 C19.5,33.3284271 20.1715729,34 21,34 L21,34 L27,34 C27.8284271,34 28.5,33.3284271 28.5,32.5 C28.5,31.6715729 27.8284271,31 27,31 L27,31 L25.5,31 L25.5,20.5 C25.5,19.6715729 24.8284271,19 24,19 L24,19 Z M24,13 C22.8954305,13 22,13.8954305 22,15 C22,16.1045695 22.8954305,17 24,17 C25.1045695,17 26,16.1045695 26,15 C26,13.8954305 25.1045695,13 24,13 Z">
                </path>
              </svg>
            </div>
            <div class="el-result__subtitle">
              <p style=" opacity: 0.6;">请先选择需要配置的店铺</p>
            </div>
          </div>
          <!-- <el-result icon="info"
                     subTitle="无配置，请新增配置"> -->
          <!-- <template slot="extra"> -->
          <!-- <el-button type="primary"
                         :loading="loading"
                         icon="el-icon-circle-plus-outline"
                         @click="handleAdd">新增配置</el-button> -->
          <!-- <el-button type="primary"
                         size="medium">返回</el-button> -->
          <!-- </template> -->
          <!-- </el-result> -->
        </el-col>

      </el-row>

    </el-card>
    <el-card class="
                     button-box"
             v-if="emptyFlag">

      <el-row type="flex"
              justify="center">
        <el-col :sm="12"
                :lg="6">

          <div class="el-result">
            <div class="el-result__icon">
              <svg viewBox="0 0 48 48"
                   xmlns="http://www.w3.org/2000/svg"
                   class="icon-info">
                <path
                      d="M24,4 C35.045695,4 44,12.954305 44,24 C44,35.045695 35.045695,44 24,44 C12.954305,44 4,35.045695 4,24 C4,12.954305 12.954305,4 24,4 Z M24,19 L21,19 C20.1715729,19 19.5,19.6715729 19.5,20.5 C19.5,21.3284271 20.1715729,22 21,22 L21,22 L22.5,22 L22.5,31 L21,31 C20.1715729,31 19.5,31.6715729 19.5,32.5 C19.5,33.3284271 20.1715729,34 21,34 L21,34 L27,34 C27.8284271,34 28.5,33.3284271 28.5,32.5 C28.5,31.6715729 27.8284271,31 27,31 L27,31 L25.5,31 L25.5,20.5 C25.5,19.6715729 24.8284271,19 24,19 L24,19 Z M24,13 C22.8954305,13 22,13.8954305 22,15 C22,16.1045695 22.8954305,17 24,17 C25.1045695,17 26,16.1045695 26,15 C26,13.8954305 25.1045695,13 24,13 Z">
                </path>
              </svg>
            </div>
            <div class="el-result__subtitle">
              <p style=" opacity: 0.6;">无配置，请新增配置</p>
            </div>
          </div>
          <!-- <el-result icon="info"
                     subTitle="无配置，请新增配置"> -->
          <!-- <template slot="extra"> -->
          <!-- <el-button type="primary"
                         :loading="loading"
                         icon="el-icon-circle-plus-outline"
                         @click="handleAdd">新增配置</el-button> -->
          <!-- <el-button type="primary"
                         size="medium">返回</el-button> -->
          <!-- </template> -->
          <!-- </el-result> -->
        </el-col>

      </el-row>

    </el-card>
    <el-card class="
                     button-box"
             v-if="tableShow">
      <!-- <el-row type="flex"
              class="row-bg"
              v-if="getBuyerLevelData.length>0&&!setFlag"
              justify="center">
        <el-col :span="3"
                class="title">双击表格可直接进入编辑模式</el-col>
      </el-row> -->
      <div v-for="(item,index) in getBuyerLevelData"
           v-bind:key="item.id">
        <el-row type="flex"
                class="row-bg"
                justify="space-between"
                :key="index"
                v-if="index%2==0">

          <el-col :span="12"
                  class="col-border"
                  v-if="getBuyerLevelData[index]"
                  style="width: 49%">
            <div class='
                     table-title'>
              <el-col :span="6"
                      :offset="1">

                <span>
                  R值{{getBuyerLevelData[index]['month']}}个月
                </span>
              </el-col>
              <div class="col-right">
                <el-col :span="16"
                        v-if="setFlag">
                  <el-button type="primary"
                             :loading="loading"
                             v-if="getBuyerLevelData.length>0 &&getBuyerLevelData[index].edit==false"
                             @click="editRow(getBuyerLevelData[index])">编辑</el-button>
                  <el-button type="success"
                             :loading="loading"
                             v-else
                             @click="handlerEdit(getBuyerLevelData[index])">保存</el-button>
                  <el-button type="info"
                             :loading="loading"
                             v-if="getBuyerLevelData[index]['edit']==true"
                             @click="cancelEdit(getBuyerLevelData[index])">取消</el-button>
                  <el-button type="danger"
                             :loading="loading"
                             v-if="getBuyerLevelData.length>0"
                             @click="handleDel(getBuyerLevelData[index]['id'])">删除配置</el-button>
                </el-col>
              </div>

            </div>

            <el-table :data="getBuyerLevelData[index]['levelData']"
                      :header-cell-style="{ 'text-align': 'center !important' }"
                      @header-click="tableDbClick(getBuyerLevelData[index])"
                      @cell-dblclick="tableDbClick(getBuyerLevelData[index])">
              <el-table-column prop="level"
                               label="level"
                               width="150px"
                               align="center">
                <template slot-scope="scope">
                  <template v-if="getBuyerLevelData[index].edit">
                    <!-- <el-input v-model="row.level"
                              class="edit-input"
                              size="small" /> -->
                    <el-select clearable
                               v-model="scope.row.level"
                               @change="changeLevel(getBuyerLevelData[index].levelData,scope.row,scope.$index )"
                               placeholder="请选择"
                               :style="{width: '100%'}">
                      <el-option v-for="item in level_list"
                                 :key="item.label"
                                 :label="item.value"
                                 :value="item.value"
                                 :disabled="item.disabled">{{ item.label }}</el-option>
                    </el-select>
                  </template>
                  <el-tooltip content="双击可直接进入编辑模式"
                              placement="top"
                              v-else><span>{{ scope.row.level }}</span></el-tooltip>
                  <!-- <span v-else>{{ row.level }}</span> -->
                </template>

              </el-table-column>
              <el-table-column prop="count"
                               label="count"
                               align="center">
                <template slot-scope="{row}">
                  <template v-if="getBuyerLevelData[index].edit">
                    <!-- <el-input clearable
                              oninput="value=value.replace(/[^\d]/g,'');value=value.replace(/^0+(\d)/,'$1');"
                              v-model="row.count"
                              :min="1">
                    </el-input> -->
                    <el-input-number v-model="row.count"
                                     :min="1"
                                     :precision="0"
                                     :step="1"
                                     controls-position="right"
                                     class="edit-input"
                                     size="small" />
                  </template>
                  <el-tooltip content="双击可直接进入编辑模式"
                              placement="top"
                              v-else><span>{{ row.count }}</span></el-tooltip>
                  <!-- <span v-else>{{ row.count }}</span> -->
                </template>

              </el-table-column>
              <el-table-column prop="money"
                               align="center"
                               label="money">
                <template slot-scope="{row}">
                  <template v-if="getBuyerLevelData[index].edit">
                    <!-- <el-input clearable
                              oninput="value=value.replace(/[^\d]/g,'');value=value.replace(/^0+(\d)/,'$1');"
                              v-model="row.money"
                              :min="1">
                    </el-input> -->
                    <el-input-number v-model="row.money"
                                     :min="1"
                                     :precision="0"
                                     :step="1"
                                     controls-position="right"
                                     class="edit-input"
                                     size="small" />
                  </template>
                  <el-tooltip content="双击可直接进入编辑模式"
                              placement="top"
                              v-else><span>{{ row.money }}</span></el-tooltip>
                  <!-- <span v-else>{{ row.money }}</span> -->
                </template>
              </el-table-column>
              <el-table-column label="操作"
                               v-if="getBuyerLevelData[index].edit"
                               align="center">
                <template slot-scope="scope">

                  <div>
                    <el-link icon="el-icon-circle-plus"
                             type="primary"
                             v-if="scope.$index ==getBuyerLevelData[index]['levelData'].length-1"
                             :underline="false"
                             @click="addRow(getBuyerLevelData[index],scope.row)">新增行</el-link>
                  </div>
                  <div>
                    <el-link icon="el-icon-delete"
                             type="danger"
                             :underline="false"
                             v-if="getBuyerLevelData[index]['levelData'].length>1"
                             @click="removeRow(getBuyerLevelData[index],scope.row)">删除行</el-link>
                  </div>

                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="12"
                  class="col-border"
                  v-if="getBuyerLevelData[index+1]"
                  style="width: 49%">
            <div class='table-title'>
              <el-col :span="6"
                      :offset="1">

                <span>
                  R值{{getBuyerLevelData[index+1]['month']}}个月
                </span>
              </el-col>
              <div class="col-right">
                <el-col :span="16"
                        v-if="setFlag">
                  <el-button type="primary"
                             :loading="loading"
                             v-if="getBuyerLevelData.length>0 &&getBuyerLevelData[index+1].edit==false"
                             @click="editRow(getBuyerLevelData[index+1])">编辑</el-button>
                  <el-button type="success"
                             :loading="loading"
                             v-else
                             @click="handlerEdit(getBuyerLevelData[index+1])">保存</el-button>
                  <el-button type="info"
                             :loading="loading"
                             v-if="getBuyerLevelData[index+1]['edit']==true"
                             @click="cancelEdit(getBuyerLevelData[index+1])">取消</el-button>
                  <el-button type="danger"
                             :loading="loading"
                             v-if="getBuyerLevelData.length>0"
                             @click="handleDel(getBuyerLevelData[index+1]['id'])">删除配置</el-button>
                </el-col>
              </div>

            </div>

            <el-table :data="getBuyerLevelData[index+1]['levelData']"
                      :header-cell-style="{ 'text-align': 'center !important' }"
                      @header-click="tableDbClick(getBuyerLevelData[index+1])"
                      @cell-dblclick="tableDbClick(getBuyerLevelData[index+1])">
              <el-table-column prop="level"
                               label="level"
                               width="150px"
                               align="center">
                <template slot-scope="scope">
                  <template v-if="getBuyerLevelData[index+1].edit">
                    <!-- <el-input v-model="row.level"
                              class="edit-input"
                              size="small" /> -->
                    <el-select clearable
                               v-model="scope.row.level"
                               @change="changeLevel(getBuyerLevelData[index+1].levelData,scope.row,scope.$index )"
                               placeholder="请选择"
                               :style="{width: '100%'}">
                      <el-option v-for="item in level_list"
                                 :key="item.label"
                                 :label="item.value"
                                 :value="item.value"
                                 :disabled="item.disabled">{{ item.label }}</el-option>
                    </el-select>
                  </template>
                  <el-tooltip content="双击可直接进入编辑模式"
                              placement="top"
                              v-else><span>{{ scope.row.level }}</span></el-tooltip>
                  <!-- <span v-else>{{ row.level }}</span> -->
                </template>

              </el-table-column>
              <el-table-column prop="count"
                               label="count"
                               align="center">
                <template slot-scope="{row}">
                  <template v-if="getBuyerLevelData[index+1].edit">
                    <!-- <el-input clearable
                              oninput="value=value.replace(/[^\d]/g,'');value=value.replace(/^0+(\d)/,'$1');"
                              v-model="row.count"
                              :min="1">
                    </el-input> -->
                    <el-input-number v-model="row.count"
                                     :min="1"
                                     :precision="0"
                                     :step="1"
                                     controls-position="right"
                                     class="edit-input"
                                     size="small" />
                  </template>
                  <el-tooltip content="双击可直接进入编辑模式"
                              placement="top"
                              v-else><span>{{ row.count }}</span></el-tooltip>
                  <!-- <span v-else>{{ row.count }}</span> -->
                </template>

              </el-table-column>
              <el-table-column prop="money"
                               align="center"
                               label="money">
                <template slot-scope="{row}">
                  <template v-if="getBuyerLevelData[index+1].edit">
                    <el-input-number v-model="row.money"
                                     :min="1"
                                     :precision="0"
                                     :step="1"
                                     controls-position="right"
                                     class="edit-input"
                                     size="small" />
                    <!-- <el-input clearable
                              oninput="value=value.replace(/[^\d]/g,'');value=value.replace(/^0+(\d)/,'$1');"
                              v-model="row.money"
                              :min="1"> -->
                    <!-- </el-input> -->
                  </template>
                  <el-tooltip content="双击可直接进入编辑模式"
                              placement="top"
                              v-else><span>{{ row.money }}</span></el-tooltip>
                  <!-- <span v-else>{{ row.money }}</span> -->
                </template>
              </el-table-column>
              <el-table-column label="操作"
                               v-if="getBuyerLevelData[index+1].edit"
                               align="center">
                <template slot-scope="scope">
                  <div>
                    <el-link icon="el-icon-circle-plus"
                             type="primary"
                             v-if="scope.$index ==getBuyerLevelData[index+1]['levelData'].length-1"
                             :underline="false"
                             @click="addRow(getBuyerLevelData[index+1],scope.row)">新增行</el-link>
                  </div>
                  <div>
                    <el-link icon="el-icon-delete"
                             type="danger"
                             :underline="false"
                             v-if="getBuyerLevelData[index+1]['levelData'].length>1"
                             @click="removeRow(getBuyerLevelData[index+1],scope.row)">删除行</el-link>
                  </div>

                </template>
              </el-table-column>
            </el-table>
          </el-col>

        </el-row>
      </div>

    </el-card>
    <set-dialog ref="refSetDialog"
                :queryInfo="form"></set-dialog>

  </div>
</template>

<script>
import {
  getplatlists,
  getptnlists,
  getshoplists,
  gettradestatus,
  gettradefrom,
} from '@/common/mixins/select'
import SearchMixin from '@/common/mixins/search-mixin'
import ActionLine from '@/common/mixins/action-line'
import { dealReturn } from '@/common/js/index.js'
import * as Desc from './desc'
import SetDialog from './dialog'

const tempPrefixeUrl = 'http://test.databankapi.transecs.com/'
export default {
  mixins: [getplatlists, getptnlists, getshoplists, gettradefrom],
  components: {
    SetDialog,
  },
  data() {
    return {
      form: {
        profession: '',
        store: '',
        business: '',
      },
      loading: false,
      tableData: [],
      msg: '',
      Desc,
      getBuyerLevelData: [],
      tableD: [],
      tableShow: true,
      setFlag: false,
      addFalg: false,
      reportTypeList: [],
      emptyFlag: false,
      'label-width': '90px',
      type_list: [
        { name: '销售额单月', value: 1 },
        { name: '顾客继续新规', value: 2 },
        { name: '顾客Recency&运转率', value: 3 },
        { name: '顾客F×M累计', value: 4 },
        { name: '顾客level报表', value: 5 },
        { name: '顾客继续-既存', value: 6 },
        { name: '顾客继续-整体', value: 7 },
        { name: '销售额移动和', value: 8 },
        { name: '顾客存活', value: 9 },
        { name: '顾客FM累计-12个月', value: 10 },
        { name: '商品-新客', value: 11 },
        { name: '商品-交叉营销', value: 12 },
        { name: '商品-继续', value: 13 },
      ],
      level_list: [
        {
          value: 'A',
          label: 'A',
          disabled: false,
        },
        {
          value: 'B',
          label: 'B',
          disabled: false,
        },
        {
          value: 'C',
          label: 'C',
          disabled: false,
        },
        {
          value: 'D',
          label: 'D',
          disabled: false,
        },
        {
          value: 'E',
          label: 'E',
          disabled: false,
        },
        {
          value: 'F',
          label: 'F',
          disabled: false,
        },
        {
          value: 'G',
          label: 'G',
          disabled: false,
        },
        {
          value: 'H',
          label: 'H',
          disabled: false,
        },
        {
          value: 'I',
          label: 'I',
          disabled: false,
        },
        {
          value: 'J',
          label: 'J',
          disabled: false,
        },
        {
          value: 'K',
          label: 'K',
          disabled: false,
        },
        {
          value: 'L',
          label: 'L',
          disabled: false,
        },
        {
          value: 'M',
          label: 'M',
          disabled: false,
        },
        {
          value: 'N',
          label: 'N',
          disabled: false,
        },
        {
          value: 'O',
          label: 'O',
          disabled: false,
        },
        {
          value: 'P',
          label: 'P',
          disabled: false,
        },
        {
          value: 'Q',
          label: 'Q',
          disabled: false,
        },
        {
          value: 'R',
          label: 'R',
          disabled: false,
        },
        {
          value: 'S',
          label: 'S',
          disabled: false,
        },
        {
          value: 'T',
          label: 'T',
          disabled: false,
        },
        {
          value: 'U',
          label: 'U',
          disabled: false,
        },
        {
          value: 'V',
          label: 'V',
          disabled: false,
        },
        {
          value: 'W',
          label: 'W',
          disabled: false,
        },
        {
          value: 'X',
          label: 'X',
          disabled: false,
        },
        {
          value: 'Y',
          label: 'Y',
          disabled: false,
        },
        {
          value: 'Z',
          label: 'Z',
          disabled: false,
        },
      ],
    }
  },
  created() {
    // this.getTableData();
    // this.getOperatelogReporttype()
  },
  watch: {
    'form.store': {
      handler: function (val) {
        // console.log("form.ptnCode watch", val);
        console.log('store change')
        this.changeSearch()
      },
    },
    'form.business': {
      handler: function (val) {
        // console.log("form.ptnCode watch", val);
        console.log('business change')
      },
    },
    'form.profession': {
      handler: function (val) {
        // console.log("form.ptnCode watch", val);
        console.log('profession change')
        this.changeSearch()
      },
    },
  },
  methods: {
    changeLevel(data, row, rowIndex) {
      console.log(data, row, rowIndex)
      console.log('row.levle', row.level)
      if (row.level != '') {
        for (var index = 0; index < data.length; index++) {
          console.log(row.level, data[index].level)
          if (index != rowIndex) {
            if (row.level == data[index].level) {
              row.level = ''
              return this.$message.error('level已存在')
            }
          }
        }
        // data.forEach((v) => {
        //   console.log(v.level, row.level)
        //   if (row.level == v.level) {
        //     row.level = ''
        //     return this.$message.error('level已存在')
        //   }
        // })
      }

      console.log(this.level_list)
    },
    handleSet() {
      if (this.setFlag) {
        for (var item of this.getBuyerLevelData) {
          if (item.edit) {
            this.cancelEdit(item)
          }
        }
      }
      this.setFlag = !this.setFlag
    },
    async handleAdd() {
      // let { data, err } = await this.axiosApi(set_api);
      if (this.form.profession && this.form.business && this.form.store) {
        // this.getReplenishSetByStore()
        this.$refs.refSetDialog.show()
      } else {
        this.$message.error('行业、商家、店铺必选')
      }
    },
    async getBuyerLevel() {
      this.getBuyerLevelData = []
      console.log(this.form.business)
      console.log(this.form.store)
      if (!this.form.store) {
        return
      }

      let { data, err } = await this.axiosApi(Desc.get_buyer_level, {
        store: this.form.store,
        business: this.form.business,
      })
      console.log('data', data.data.data)
      // console.log(JSON.parse(data.data.data[0]))
      if (data.data.data.length > 0) {
        // this.getBuyerLevelData = (data.data.data)
        this.getBuyerLevelData = []
        console.log(this.getBuyerLevelData)
        data.data.data.forEach((element) => {
          console.log(element)
          this.getBuyerLevelData.push({
            id: element.id,
            originalid: element.id,
            month: element.month,
            originalmonth: element.month,
            store: element.store,
            originalstore: element.store,
            business: element.business,
            originalbusiness: element.business,
            levelData: JSON.parse(element.levelData),
            originallevelData: element.levelData,
          })
        })
        this.getBuyerLevelData = this.getBuyerLevelData.map((v) => {
          v.levelData = v.levelData.map((x) => {
            this.$set(x, 'edit', false)
            return x
          })
          this.$set(v, 'edit', false)
          return v
        })
        console.log('1')
        console.log(this.getBuyerLevelData)
        this.tableShow = true
        this.emptyFlag = false
      } else {
        this.tableShow = false
        this.emptyFlag = true
        console.log('2')
        this.$message({
          showClose: true,
          message: '无配置，请新增配置',
          type: 'error',
          duration: 1000,
        })
      }
    },
    changeSearch() {
      this.tableShow = false
      this.setFlag = false
      this.emptyFlag = false
      this.getBuyerLevelData = []
    },
    removeRow(data, row) {
      console.log(data, row)
      var index = data.levelData.indexOf(row)
      if (index !== -1) {
        data.levelData.splice(index, 1)
      }
    },
    saveRow(row) {
      if (!row.level) {
        return this.$message({
          showClose: true,
          message: 'level必填',
          type: 'error',
          duration: 1000,
        })
      }
      if (!row.count) {
        return this.$message({
          showClose: true,
          message: 'count必填',
          type: 'error',
          duration: 1000,
        })
      }
      if (!row.money) {
        return this.$message({
          showClose: true,
          message: 'money必填',
          type: 'error',
          duration: 1000,
        })
      }
      this.addFalg = false
    },
    changeType() {
      this.form.remark = ''
      this.form.time = ''
      if (this.form.type != 5) {
        console.log('change')

        if (this.form.interval) {
          delete this.form.interval
        }
      } else {
        this.form.time = ''
      }
    },
    resetForm() {
      this.form = {
        type: '',
        profession: '',
        store: '',
        business: '',
      }
    },
    editRow(row) {
      console.log(row)
      row.edit = !row.edit
    },
    addRow(data, row) {
      if (!row.level) {
        return this.$message({
          showClose: true,
          message: 'level必填',
          type: 'error',
          duration: 1000,
        })
      } else {
        var reg = new RegExp('^[A-Z]$')
        console.log(reg.test(row.level))
        if (!reg.test(row.level)) {
          return this.$message({
            showClose: true,
            message: 'level必须为【A-Z】一位字母',
            type: 'error',
            duration: 1000,
          })
        }
      }

      if (!row.count) {
        return this.$message({
          showClose: true,
          message: 'count必填',
          type: 'error',
          duration: 1000,
        })
      }
      if (!row.money) {
        return this.$message({
          showClose: true,
          message: 'money必填',
          type: 'error',
          duration: 1000,
        })
      }
      data.levelData.push({ level: '', count: '', money: '' })
      this.addFalg = true
    },
    tableDbClick(row) {
      // this.handleSet()
      if (!this.setFlag) {
        this.setFlag = true
      }
      if (!row.edit) {
        row.edit = true
      }
    },
    cancelEdit(row) {
      console.log(row)
      ;(row.levelData = JSON.parse(row.originallevelData)), (row.edit = false)
    },
    async handlerEdit(row) {
      console.log(row)
      for (var item of row.levelData) {
        if (!item.level) {
          return this.$message.error('level必填')
        } else {
          var reg = new RegExp('^[A-Z]$')
          console.log(reg.test(item.level))
          if (!reg.test(item.level)) {
            return this.$message({
              showClose: true,
              message: 'level必须为【A-Z】一位字母',
              type: 'error',
              duration: 1000,
            })
          }
        }
        if (!item.count) {
          return this.$message({
            showClose: true,
            message: 'count必填',
            type: 'error',
            duration: 1000,
          })
        }
        if (!item.money) {
          return this.$message({
            showClose: true,
            message: 'money必填',
            type: 'error',
            duration: 1000,
          })
        }
      }

      this.loading = true
      let copy = Object.assign({}, row)
      delete copy.edit
      copy.levelData = copy.levelData.map((v) => {
        delete v.edit
        return v
      })
      console.log(copy)
      this.loading = false
      this.addFalg = false
      this.setFlag = false
      row.edit = false
      var payload_data = {
        store: copy.store,
        business: copy.business,
        month: copy.month,
        levelData: copy.levelData,
      }
      console.log(payload_data)
      let { data, err } = await this.axiosApi(
        this.Desc.create_buyer_level,
        payload_data
      )
      this.loading = false
      console.log(data)
      if (data && data.data.meta && data.data.meta.status === 200) {
        //
        this.getBuyerLevel()
      } else {
        // this.$message.error(err.response.data.message);
      }
      dealReturn(data, err)
    },
    handleDel(id) {
      this.$confirm('此操作将永久删除该配置, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          console.log(id)
          this.delApi(id)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    async delApi(id) {
      this.loading = true
      let { data, err } = await this.axiosApi(Desc.del_buyer_level, { id })
      console.log('data', data)
      this.loading = false

      if (data && data.data.meta.status == 200) {
        this.getBuyerLevel()
        this.setFlag = false
        this.$message({
          type: 'success',
          message: '删除成功!',
        })
        console.log(this.getBuyerLevelData)
      }
      dealReturn(data, err)
    },
    handleClick() {
      // if (!this._collectQuery()) {
      //   return
      // }

      if (!this.form.profession) {
        this.$message.error('请先选择行业')
        return
      }
      if (!this.form.store) {
        this.$message.error('请先选择店铺')
        return
      }
      if (!this.form.business) {
        this.$message.error('请先选择商家')
        return
      }
      this.getBuyerLevelData.push({
        store: this.form.store,
        business: this.form.business,
        levelData: [{ level: 'A', count: 6, money: 1000 }],
      })
      this.tableShow = true

      console.log(this.getBuyerLevelData)
      // if (!this.form.time) {
      //   this.$message.error('请选择时间')
      //   return
      // }
      // // this.getData()
      // console.log('this.queryPrdlists', this.queryPrdlists)
      // console.log(this.form)
      // this.rfmReport()
    },

    async rfmReport() {
      this.loading = true
      let { data, err } = await this.axiosApi(Desc.rfm_api, this.form)
      console.log('data', data)
      this.loading = false
      if (data && data.data.meta.status == 200) {
        this.$alert('导出成功，请稍后在导出日志查看', '导出成功', {
          confirmButtonText: '确定',
          type: 'success',
        })
      }
      dealReturn(data, err)
    },
  },
}
</script>

<style lang="scss" scoped>
.title {
  display:inline;
  padding-left: 50px;
  font-size: 12px;
  color: #909399;
  height: 100px;
}
.row-bg{
// padding: 20px 20px;
// margin: 20px;
// background-color: red;
margin-bottom: 10px;
}
.table-title{
  color: #606266
;
  font-weight: 800;
  // padding-bottom: 10px;
  margin-top: 10px;
  // background-color: red;
}
.col-border{
  border: 1px solid #EBEEF5;
}
.col-right{
  text-align: right;
  width: 100%;


}
.icon-info {
    fill: #909399;
}
.el-result__icon svg {
    width: 64px;
    height: 64px;
}
svg:not(:root) {
    overflow: hidden;
}
.el-result {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-direction: column;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 40px 30px;
}
.el-result__subtitle {
    margin-top: 10px;
}
.el-result__subtitle p {
    margin: 0;
    font-size: 14px;
    color: #606266;
    line-height: 1.3;}
   
</style>>




// WEBPACK FOOTER //
// src/views/rfm/rfmBuyerLevel/index.vue